import { getCompareDetailV5, getCompareGoodsList, shopifyCartAdd } from "@utils/api";

if (!customElements.get("v5-pdp-comparison")) {
  class V5PdpComparison extends HTMLElement {
    constructor() {
      super();
      this.DOM = {};
      this.text = {}
      this.isMobile = window.innerWidth < 1024;
      this._handlers = new Map();
      this.selectProductList = []
      this.productList = []
      this.openAutoDiscountPrice = false
      this.mbGridClass = "17.5rem_17.5rem_17.5rem" // 移动端grid布局class
      this.totleWidth = '54.5rem'
    }
    connectedCallback() {
        this.DOM = {
            productSelect: this.querySelector('.product-select') || null,
            productContent: this.querySelector('.product-content') || null,
            backUpLevel: this.querySelector('.back-up-level') || null,
            kitchenHoursExample: this.querySelector('.kitchen-hours-example') || null,
            bedroomHoursExample: this.querySelector('.bedroom-hours-example') || null,
            techSpecs: this.querySelector('.tech-specs') || null,
            viewMore: this.querySelector('.view-more') || null,
            viewMoreParent: this.querySelector('.view-more-parent') || null
        }
        this.text = {
            currentProductText: this.getAttribute('current_product_text'),
            backUpLevelText: this.getAttribute('back_up_level_text') || '',
            kitchenHoursExampleText: this.getAttribute('kitchen_hours_example_text') || '',
            bedroomHoursExampleText: this.getAttribute('bedroom_hours_example_text') || '',
            basicText: this.getAttribute('basic_text'),
            completeText: this.getAttribute('complete_text'),
            productTitle: this.getAttribute('product_title') || ''
        }
        this.openAutoDiscountPrice = this.getAttribute("open_auto_discount_price") === "true"
        this.variantId = this.getAttribute('data-id')
        this.skuIdList = [this.variantId]
        this.updateContent()
        this.onEvent()
        if (!this.isMobile) this.onInterViewPort()
    }
    disconnectedCallback() {
        document.removeEventListener('variantChangeEvent', this._handlers.get('variantChangeEvent'));
    }
    getPdpTabHeight() {
      return document.querySelector(".section-navigation")?.offsetHeight || 0;
    }

    // 监听当前组件是否快要进入视窗
    onInterViewPort () {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const h = this.getPdpTabHeight() - 1
                    this.DOM.productSelect.style.top = `${h}px`
                }
            });
        }, { root: null, rootMargin: "200px", threshold: 0 });
        observer.observe(this);
    }
    // 更新数据
    onEvent() {
        const that = this
        // 监听变体切换
        if (document.querySelector('variant-fields')) {
            document.addEventListener('variantChangeEvent', async e => {
                const currentVariant = e.detail.variant
                if (currentVariant) {
                    this.variantId = currentVariant.id
                    this.skuIdList = [currentVariant.id]
                    // 变体切换涉及接口请求，和产品对比详情
                    await that.getDetail();
                }
            })
        }
        // 监听Select 选择框
        this.DOM.productSelect.addEventListener('click', (e) => {
            const selectInput = e.target.closest('.select-input');
            if(!selectInput) return
            // 先清除其他 active 状态（如果有多个 select-item）
            this.DOM.productSelect.querySelectorAll('.select-item.active')?.forEach(el => {
                el.classList.remove('active');
            });
            // 给当前 selectInput 的父级元素添加 active
            const parentItem = selectInput.closest('.select-item');
            if (parentItem) parentItem.classList.add('active');
        })
        // 点击空白处：关闭当前 active 的元素
        document.addEventListener('click', (e) => {
            const activeItem = this.DOM.productSelect.querySelector('.select-item.active');
            if (!activeItem) return;
            // 如果点击不在 activeItem 内 → 关闭
            if (!activeItem.contains(e.target)) {
                activeItem.classList.remove('active');
            }
            // Ga埋点
            const gaParams = {
                product_spu_name: this.text.productTitle,
                module: 'ProductsCompare_3',
                position: this.text.currentProductText,
                button: 'Filter'
            }
            gaPushDataLayer('5.0_products_details_page_user_clicks', gaParams);
        });
        // 监听View More
        this.DOM.viewMore.addEventListener('click', e => {
            this.DOM.techSpecs.classList.remove('max-h-[6.75rem]')
            this.DOM.techSpecs.classList.add('!max-h-none')
            this.DOM.viewMoreParent.style.display = "none"
        })
        // 监听加购
        this.addEventListener("click", (e) => {
            const btn = e.target.closest("[compare-add-to-cart]");
            if(btn) this.addToCart(btn);
        })

        // 监听下拉选项
        this.addEventListener('click', async (e) => {
            const selectOption = e.target.closest('.select-option');
            if (!selectOption) return
            const { sku_id, index } = selectOption.dataset
            const skuId = Number(sku_id)
            if (skuId === this.variantId) return
            if (this.skuIdList[index] === skuId) return
            if (this.skuIdList.includes(skuId)) {
                const j = this.skuIdList.findIndex(item => item === skuId)
                const id = this.skuIdList[j]
                this.skuIdList[j] = this.skuIdList[index]
                this.skuIdList[index] = id
            } else {
                this.skuIdList[index] = skuId
            }
            await this.getDetail()
        })
    }
    async updateContent() {
        await this.getDetail()
        this.getGoodsList()
    }
    // 获取详情
    async getDetail() {
        const params = {
            skuIdList: this.skuIdList,
            pageType: 2
        }
        const {data} = await getCompareDetailV5(params)
        this.selectProductList = data.fourProductResps || []
        this.detailList = data.dictInfoResps || []
        this.fiveCusCompareGeneralResp = data.fiveCusCompareGeneralResp || {}
        this.fourProductResps = data.fourProductResps || []
        // 移动端的时候设置宽度
        if(this.isMobile) {
            const length = this.selectProductList.length
            this.totleWidth = `${length * 17.5}rem`
        }
        this.skuIdList = this.fourProductResps.map(item => item.skuId)
        // 渲染对比产品
        this.DOM.productSelect.innerHTML = this.renderProductSelect()
        this.DOM.productContent.innerHTML = this.renderProductContent()
        this.DOM.backUpLevel && (this.DOM.backUpLevel.innerHTML = this.renderBackUpLevel())
        this.DOM.kitchenHoursExample && (this.DOM.kitchenHoursExample.innerHTML = this.renderKitchenHoursExample())
        this.DOM.bedroomHoursExample && (this.DOM.bedroomHoursExample.innerHTML = this.renderBedRoomHoursExample())
        this.DOM.techSpecs.innerHTML = this.renderTechSpecs()
        if (this.productList.length) this.renderProductList()

        // 当元素渲染完毕之后，来处理full-width的宽度
        this.observeFullWidth()
    }
    // 监听所有的full-width
    observeFullWidth() {
        if(this.isMobile) {
            const length = this.selectProductList.length
            const width = `${17.5 * length + 1*(length - 1)}rem`
            this.querySelectorAll('.full-width').forEach(el => {
                el.style.width = width;
            });
        }
    }
    // 渲染对比选择
    renderProductSelect() {
        if (this.selectProductList.length === 0) return ''
        let html = this.isMobile ? '' : '<div></div>'
        this.selectProductList.forEach((item, index) => {
            const { title, skuId} = item
            if (index === 0) {
                html += `
                    <div class="bg-[#242F20] px-[1.5rem] py-[1.25rem] lg:py-[0.875rem] h-[4.5rem]">
                        <div class="mb-2.5 text-[0.75rem] lg:text-[0.875rem] leading-[1.1] text-[#fff] font-normal"> ${this.text.currentProductText} </div>
                        <div class="font-semibold text-[0.875rem] lg:text-[1.25rem] line-clamp-1 text-[#fff]" > ${title} </div>
                    </div>
                `
            } else {
                html += `
                    <div class="p-2 h-[4.5rem]">
                        <div class="relative w-full h-[3.5rem] select-item">
                            <div class="flex items-center border bg-[#fff] border-[#C6C7C8] border-solid h-[3.5rem] py-2 pl-3 pr-8 cursor-pointer select-input" data-index="${index}">
                                <span class="pointer-events-none font-semibold text-[1rem] text-[#242F20] line-clamp-2" >
                                    ${title}
                                </span>
                            </div>
                            <div class="bg-[#fff] border-[#dcdcdc] py-1 border-solid border w-full top-[calc(100%+2px)] left-0 max-h-[27.5rem] absolute overflow-y-auto invisible opacity-0 select-dropdown" data-sku="${skuId}">
                            </div>
                        </div>
                    </div>
                `
            }
        })
        return html
    }
    // 渲染产品信息
    renderProductContent() {
        if (this.selectProductList.length === 0) return ''
        let html = this.isMobile ? '' : '<div></div>'
        this.selectProductList.forEach(item => {
            const current_price = Math.min(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0)
            const origin_price = Math.max(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0, item.shopifyFrontOriginalPrice || 0)
            html += `
                <div>
                    <div class="w-full h-[17rem] flex items-center justify-center images">
                        <a href="${item.goodUrl}?variant=${item.skuId}">
                            <img class="h-[17rem] aspect-[1/1]" width="360" height="272" loading="lazy" src="${item.image}&width=360">
                        </a>
                    </div>
                    <div class="px-6 flex items-end justify-between mb-6">
                        <div class="text-center text-[#242F20]">
                            <span class="lg:text-[1.25rem] text-[1rem] font-semibold">
                                ${ this.openAutoDiscountPrice && item.autoDiscountPrice > 0 ? window.formatMoney(current_price) : window.formatMoney(item.shopifyFrontprice, window?.pageInfo?.currency?.money_format) }
                            </span>
                            <span class="text-[0.75rem] lg:text-[0.875rem] font-normal line-through pl-1">
                                ${
                                    this.openAutoDiscountPrice && item.autoDiscountPrice > 0
                                     ?  (origin_price > current_price
                                                                ? window.formatMoney(origin_price)
                                                                : '')
                                     : (item.shopifyFrontOriginalPrice && item.shopifyFrontOriginalPrice > item.shopifyFrontprice ?
                                        `${window.formatMoney(item.shopifyFrontOriginalPrice, window.pageInfo.currency.money_format)}` : '')
                                }
                            </span>
                        </div>
                        <div class="w-9 h-9 lg:w-10 lg:h-10 bg-[var(--jds-color-primary)] ${item.available ? 'cursor-pointer jky-v5-button' : 'cursor-not-allowed opacity-40'}" ${item.available ? `data-id="${item.skuId}" compare-add-to-cart` : ''}>
                            <svg class="text-[#fff] w-full h-full" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.71484 8.00781H9.65015L11.2313 27.1924H29.5727L34.6183 12.2102H14.3796" stroke="currentColor" stroke-width="2" stroke-linejoin="bevel"/>
                                <path d="M17.0781 18.9531H26.0731" stroke="currentColor" stroke-width="2" />
                                <path d="M21.5742 23.4453V14.4503" stroke="currentColor" stroke-width="2" />
                                <path d="M16.5056 30.8516C16.5056 31.9383 15.6247 32.8192 14.538 32.8192C13.4513 32.8192 12.5703 31.9383 12.5703 30.8516" stroke="currentColor" stroke-width="2"/>
                                <path d="M28.2009 30.8516C28.2009 31.9383 27.32 32.8192 26.2333 32.8192C25.1466 32.8192 24.2656 31.9383 24.2656 30.8516" stroke="currentColor" stroke-width="2"/>
                            </svg>
                        </div>
                    </div>
                </div>
            `
        })
        return html
    }

    // 渲染back-up-level参数
    renderBackUpLevel() {
        if (this.selectProductList.length === 0) return ''
        if (!this.DOM.backUpLevel || !this.fiveCusCompareGeneralResp?.backupLevel.length) return ''
        let html = `
            <div class="h-[2.25rem] lg:h-[4.75rem] bg-[#F5F5F3] lg:bg-transparent px-4 lg:px-6 font-semibold text-[1rem] lg:text-[1.25rem] text-[#242F20E5] flex items-center full-width">${this.text.backUpLevelText}</div>
            ${this.isMobile ? `<div class="grid grid-cols-[${this.mbGridClass}] gap-4">`: ''}
        `
        this.fiveCusCompareGeneralResp.backupLevel.forEach((item) => {
            let lineHtml = '';
            [1, 2, 3, 4, 5, 6, 7].forEach(item1 => {
                lineHtml += `
                    <span class="flex-1 ${item1 === (Number(item) || 1) ? 'h-1 bg-[var(--jds-color-primary)]' : 'h-0.5 bg-[#C3C3BE]'} "></span>
                `
            })
            html += `
                <div class="px-6 py-6 lg:py-0 flex flex-col items-center justify-center">
                    <div class="flex w-full items-center">
                        ${lineHtml}
                    </div>
                    <div class="w-full mt-4 text-[#242F20E5] flex items-center justify-between text-[0.875rem] font-normal">
                        <span>${this.text.basicText}</span>
                        <span>${this.text.completeText}</span>
                    </div>
                </div>
            `
        })
        html += this.isMobile ? '</div>': ''
        return html
    }
    // 渲染KitchenHoursExample参数
    renderKitchenHoursExample() {
        if (this.selectProductList.length === 0) return ''
        if (!this.DOM.kitchenHoursExample) return ''
        const list = (this.isMobile ? this.fiveCusCompareGeneralResp?.kitchenMobile :this.fiveCusCompareGeneralResp?.kitchenPc ) || []
        let html = `
            <div class="h-[2.25rem] lg:h-[9.875rem] bg-[#F5F5F3] lg:bg-transparent px-4 lg:px-6 font-semibold  text-[1rem] lg:text-[1.25rem] text-[#242F20E5] flex items-center full-width">${this.text.kitchenHoursExampleText}</div>
            ${this.isMobile ? `<div class="grid grid-cols-[${this.mbGridClass}] gap-4">`: ''}
        `
        list.forEach((item) => {
            html += `
                <div class="px-6 h-[6.75rem] lg:h-[9.875rem] flex items-center justify-center">
                    ${item ? `
                        <img class="max-h-[6rem] lg:max-h-[9rem] object-cover" width="360" height="144" loading="lazy" src="${item}">
                    `: `一`}
                </div>
            `
        })
        html += this.isMobile ? '</div>': ''
        return html
    }
    // 渲染KitchenHoursExample参数
    renderBedRoomHoursExample() {
        if (this.selectProductList.length === 0) return ''
        if (!this.DOM.bedroomHoursExample) return ''
        const list = (this.isMobile ? this.fiveCusCompareGeneralResp?.bedroomMobile :this.fiveCusCompareGeneralResp?.bedroomPc ) || []
        let html = `
            <div class="h-[2.25rem] lg:h-[9.875rem] bg-[#F5F5F3] lg:bg-transparent px-4 lg:px-6 font-semibold  text-[1rem] lg:text-[1.25rem] text-[#242F20E5] flex items-center full-width">${this.text.bedroomHoursExampleText}</div>
            ${this.isMobile ? `<div class="grid grid-cols-[${this.mbGridClass}] gap-4">`: ''}
        `
        list.forEach((item) => {
            html += `
                <div class="px-6 h-[6.75rem] lg:h-[9.875rem] flex items-center justify-center">
                    ${item ? `
                        <img class="max-h-[6rem] lg:max-h-[9rem] object-cover" width="360" height="144" loading="lazy" src="${item}">
                    `: `一`}
                </div>
            `
        })
        html += this.isMobile ? '</div>': ''
        return html
    }
    // 渲染对比详情
    renderTechSpecs() {
        if (!Array.isArray(this.detailList)) return '';
        // 生成每个子项的值列
        const getValHtml = (values = []) => {
            return values.map(val => `
                <div class="px-4 lg:px-6 py-[1.375rem] min-h-[3.75rem] flex items-center text-[1rem] leading-[1.2] text-[#242F20E5] justify-center text-center">
                    ${val || '一'}
                </div>
            `).join('');
        };

        // 生成每个子项的 HTML
        const getChildHtml = (child) => {
            const valHtml = getValHtml(child.showValue || []);
            return `
                <div class="text-left lg:grid grid-cols-[14rem_22.5rem_22.5rem_22.5rem] lg:border-b border-solid border-[#E2E3E3]">
                    <div class="px-4 lg:px-6 min-h-[2.25rem] lg:min-h-[3.75rem] bg-[#F5F5F3] lg:bg-transparent font-semibold text-[1rem] lg:text-[1.125rem] leading-[1.2] text-[#242F20E5] flex items-center full-width">
                        ${child.infoShowTitle}
                    </div>
                    ${this.isMobile ? `<div class="grid grid-cols-[17.5rem_17.5rem_17.5rem] gap-4">`: ''}
                        ${valHtml}
                    ${this.isMobile ? '</div>': ''}
                </div>
            `;
        };

        // 生成整个规格 HTML
        return this.detailList.map(item => {
            const titleHtml = `
                <div class="text-left pl-6 bg-[rgb(232,232,229,0.9)] text-[1rem] h-11 flex items-center font-semibold full-width">
                    ${item.infoShowTitle}
                </div>
            `;
            const childrenHtml = (item.childInfos || []).map(getChildHtml).join('');
            return titleHtml + childrenHtml;
        }).join('');
    }
    // 添加购物车
    async addToCart(el) {
        el.classList.add('loading')
        const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        try {
            const { id } = el.dataset;
            const items = [{ id, quantity: 1 }]
            const res = await shopifyCartAdd({items});
            if (cart?.renderContents) {
            cart.renderContents(res);
            } else {
                window.location.href = "/cart";
            }
            const gaParams = {
                product_spu_name: this.text.productTitle,
                module: 'ProductsCompare_3',
                position: this.text.currentProductText,
                button_name: 'AddToCart'
            }
            gaPushDataLayer('5.0_products_details_page_user_clicks', gaParams);
        } catch (e) {
            console.log({e})
            e?.statusText && pushErrorMessage(e.statusText);
        } finally {
            el.classList.remove('loading')
            cart?.classList.contains("is-empty") && cart.classList.remove("is-empty");
        }
    }
    // 获取列表
    async getGoodsList() {
        const params = {
            pageType: 2,
            skuId: this.variantId
        }
        const { data: { classifyGoodsResps = [], pullDownFlag = 0 } } = await getCompareGoodsList(params)
        this.productList = classifyGoodsResps
        this.renderProductList()
    }
    // 渲染产品下拉
    renderProductList() {
        if(!this.productList.length) return
        const productMap = new Map();
        this.productList.forEach(product => {
            productMap.set(product.classifyTitle, product.fourProductResps);
        });
        this.selectProductList.forEach((item, index) => {
            if (index === 0 ) return
            const dropdownFragments = [];
            productMap.forEach((options, classifyTitle) => {
                const optionsHtml = options.map(opt => `
                    <div class="relative flex items-center text-[1rem] font-medium py-1.5 pl-3 pr-8 leading-[1.2] cursor-pointer ${item.skuId == opt.skuId ? 'active' : ''} ${this.variantId == opt.skuId ? 'cursor-not-allowed' : ''} select-option" data-classify_title="${classifyTitle}" data-title="${opt.title}" data-sku_id="${opt.skuId}" data-index="${index}" >
                        ${opt.title}
                    </div>
                `).join('');
                dropdownFragments.push(`
                    <div>
                        <div class="text-[#1a1a1a] px-3 text-[1rem] lg:text-[1.125rem] font-semibold py-1.5 group-label">${classifyTitle}</div>
                        ${optionsHtml}
                    </div>
                `);
            })
            const el = this.querySelector(`.select-dropdown[data-sku="${item.skuId}"]`)
            if (el) el.innerHTML = dropdownFragments.join('');
        })
    }
  }
  customElements.define("v5-pdp-comparison", V5PdpComparison);
}

